import always from 'ramda/es/always';
import evolve from 'ramda/es/evolve';
import omit from 'ramda/es/omit';
import assoc from 'ramda/es/assoc';

import {
  ORGS_FILTER_REQUEST,
  ORGS_FILTER_SUCCESS,
  ORGS_FILTER_FAILURE,
  ORGS_FILTER_CLEAR,
  ORGS_FILTER_DELETE,
  ORGS_FILTER_SET,
} from 'app/actions/reports/filters/orgs';


const defaultState = {
  data: {},
  selected: {},
  loading: true,
  // active: true, // всегда активный
};

const orgs = (state = defaultState, { type, payload }) => {
  switch (type) {
    case ORGS_FILTER_REQUEST: {
      return { ...state, loading: true };
    }
    case ORGS_FILTER_SUCCESS: {
      return evolve({
        data: always(payload),
        loading: always(false),
      }, state);
    }
    case ORGS_FILTER_FAILURE: {
      return { ...state, loading: false };
    }
    case ORGS_FILTER_CLEAR: {
      return defaultState;
    }
    case ORGS_FILTER_DELETE: {
      return evolve({ selected: omit(payload) }, state);
    }
    case ORGS_FILTER_SET: {
      return assoc('selected', payload, state);
    }
    default:
  }
  return state;
};

export default orgs;
